import { render, staticRenderFns } from "./BCXMessengerChatPreviewLoader.vue?vue&type=template&id=2c0a8458&scoped=true"
var script = {}
import style0 from "./BCXMessengerChatPreviewLoader.vue?vue&type=style&index=0&id=2c0a8458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a8458",
  null
  
)

export default component.exports